import { IpAddress } from "./IpAddress";
import { MacAddress } from "./MacAddress";
import { Iterable } from "../Utils/ObjUtils";
import { Dictionary } from "../Utils/Dictionary";

//export interface ArpEntryJsonWrapper {
//    arp_entry: ArpEntryJson;
//}

//export interface ArpEntryJson {
//    if_index: string;
//    ip_address: string;
//    mac_address: string;
//}

export class ArpEntry {
    //public static FromJson(entry: ArpEntryJson): ArpEntry {

    //    var arpIpAddress = IpAddress.Create(entry.ip_address);
    //    var result = new ArpEntry(arpIpAddress);

    //    if (entry.if_index !== undefined)
    //        result.IfIndex = parseInt(entry.if_index);
    //    if (entry.mac_address !== undefined)
    //        result.MacAddress = MacAddress.CreateFromString(entry.mac_address);

    //    return result;
    //}

	public IpAddress: IpAddress;
	public IfIndex: number;
	public MacAddress: MacAddress;
	public get HasMacAddress(): boolean {
		return this.MacAddress && !this.MacAddress.IsNull;
	}

	// NOTE: IPv4 / IPv6 Types represent different values
	public Type: number
	public get HasType(): boolean {
		return this.Type >= 0;
	}

	// IPv6 only
	public State: number;
	public get HasState(): boolean {
		return this.State >= 0;
	}

	constructor(ipAddress?: IpAddress) {
		this.IpAddress = ipAddress;

		this.IfIndex = -1;
		this.MacAddress = null;
		this.Type = -1;
		this.State = -1;
	}

	public Clone(cloneIp: IpAddress = null): ArpEntry {
		var newArpEntry: ArpEntry = null;

		if (cloneIp != null)
			newArpEntry = new ArpEntry(cloneIp.Clone());
		else
			newArpEntry = new ArpEntry(this.IpAddress.Clone());

		newArpEntry.IfIndex = this.IfIndex;

		if (this.HasMacAddress)
			newArpEntry.MacAddress = this.MacAddress.Clone();

		newArpEntry.Type = this.Type;
		newArpEntry.State = this.State;

		return newArpEntry;
	}
}

export class ArpTable implements Iterable<ArpEntry> {
	private _arpTable: Dictionary<IpAddress, ArpEntry>;

	constructor() {
		this._arpTable = new Dictionary<IpAddress, ArpEntry>();
	}

	public Add(arpEntry: ArpEntry) {
		if (!this._arpTable.ContainsKey(arpEntry.IpAddress)) {
			this._arpTable.Add(arpEntry.IpAddress, arpEntry);
		}
		else {
			// TODO: UPDATE the ENTRY???
		}
	}

	public Clear(): void {
		this._arpTable.Clear();
	}

	public get Count(): number {
		return (this._arpTable.Count);
	}

	public Find(ipAddress: IpAddress): ArpEntry {
		return this._arpTable.Item(ipAddress);
	}

	public Remove(arpEntry: ArpEntry): boolean {
		return this._arpTable.Remove(arpEntry.IpAddress);
	}

	public ForEach(callbackfn: (value: ArpEntry, index: number, array: ArpEntry[]) => void, thisArg?: any): void {
		this._arpTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: ArpEntry, index: number, array: ArpEntry[]) => boolean, thisArg?: any): boolean {
		return this._arpTable.Values().Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: ArpEntry, index: number, array: ArpEntry[]) => boolean, thisArg?: any): boolean {
		return this._arpTable.Values().Every(callbackfn, thisArg);
	}
}
